import { memo, Fragment } from "react";
import image from "../../../assets/images/KABCO.png";
import image2 from "../../../assets/images/KABCO.png";
const Logo = memo((props) => {
  return (
    <Fragment>
      <div className="logo-main">
        <div className="logo-normal ms-3">
          <img width="155px" src={image} alt="" />
        </div>
        <div className="logo-mini">
          <img width="38px" src={image2} alt="" />
        </div>
      </div>
    </Fragment>
  );
});

Logo.displayName = "Logo";
export default Logo;
